import React from 'react';
import CardReasonStore from 'stores/CardReasonStore';
import CardReasonEditStore from 'stores/CardReasonEditStore';
import AltContainer from 'alt-container';
import CardReasonActions from 'actions/CardReasonActions';
import CardReasonEditActions from 'actions/CardReasonEditActions';
import CardReasonPage from 'components/pure/admin/CardReasonPage';

export default class CardReasonsPageContainer extends React.PureComponent {
  componentDidMount() {
    CardReasonActions.fetchAll();
  }

  render() {
    return (
      <AltContainer
        stores={{CardReasonStore, CardReasonEditStore}}
        actions={{CardReasonActions, CardReasonEditActions}}>
        <CardReasonPage />
      </AltContainer>
    );
  }
}
